module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN304_1316536464.1215f808.png";